exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TotalSpent_component_P5-P {\n  margin-top: 10px;\n  padding-top: 20px;\n\n  border-top: 1px solid #e6e6e6\n}\n\n.TotalSpent_component_P5-P.TotalSpent_empty_1uR7 {\n  margin-top: 0;\n  border-top-color: transparent;\n}\n\n.TotalSpent_row_2Jn2 {\n  margin-bottom: 5px;\n}\n\n.TotalSpent_spendingName_1B8O {\n  display: inline-block;\n\n  width: 250px;\n}\n\n.TotalSpent_spendingValue_3Fjg {\n  display: inline-block;\n}\n\n.TotalSpent_table_15rQ {\n  padding: 15px;\n\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  background-color: #fcfbfa;\n}\n\n.TotalSpent_arrow_3fyy {\n  position: relative;\n  z-index: 1;\n  top: 7px;\n  left: 30px;\n\n  width: 14px;\n  height: 14px;\n\n  border-top: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n  border-radius: 4px 0 0;\n  background: #fcfbfa;\n\n  -webkit-transform: rotate(45deg);\n\n          transform: rotate(45deg);\n}\n\n.TotalSpent_totalName_2_i4 {\n  font-size: 22px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "TotalSpent_component_P5-P",
	"empty": "TotalSpent_empty_1uR7",
	"row": "TotalSpent_row_2Jn2",
	"spendingName": "TotalSpent_spendingName_1B8O",
	"spendingValue": "TotalSpent_spendingValue_3Fjg",
	"table": "TotalSpent_table_15rQ",
	"arrow": "TotalSpent_arrow_3fyy",
	"totalName": "TotalSpent_totalName_2_i4"
};